import React from "react";
import "./Spravy.scss";

// components
import Detail from "../../coraWebComponents/detail/DetailWrapper";

const SCHEMA = [
  {
    field: "ZP_SPRAVY_D_PUB",
    title: "Dátum publikácie",
    width: "200px",
    type: "date",
  },
  {
    field: "ZP_SPRAVY_TEXT",
    title: "Text",
    width: "auto",
    type: "text",
    defaultExpanded: true,
  },
];

class DetailComponent extends React.Component {
  render() {
    const { allData, data, onGet, isLoading } = this.props;

    return (
      <Detail
        allData={allData}
        onUpdate={() => { }}
        onSubmit={() => { }}
        onGet={onGet}
        onChange={() => { }}
        schema={SCHEMA}
        data={data}
        isLoading={isLoading}
        primaryField="I_ZP_SPRAVY_UZ"
        hiddenSave={true}
      />
    );
  }
}

export default DetailComponent;
